import { shape, arrayOf, number, string, oneOfType } from 'prop-types';

export const checkoutFormTypes = shape({
  name: string,
  email: string,
  phone: string,
  cardCode: oneOfType([number, string])
});

export const suggestiveSells = shape({
  id: number.isRequired,
  name: string.isRequired,
  category: string.isRequired,
  description: string,
  pictures: arrayOf(
    shape({
      id: number.isRequired,
      url: string.isRequired
    }).isRequired
  ),
  menuableId: number,
  menuableType: string,
  points: number,
  price: number.isRequired,
  priceCurrency: string.isRequired
});

export const suggestiveSellsPropTypes = arrayOf(suggestiveSells);
